import { memo } from "react";
import { styled } from "../../../../lib/styled";
import { feedOutcomeCounts } from "../../../../lib/corpusFeedView";
import type { CorpusFeedStatistics } from "@shared/types/corpus/api.ts";
import { FeedOutcomeSwatch } from "./FeedOutcomeSwatch";

const Track = styled("div")(({ theme }) => ({
  display: "flex",
  height: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  overflow: "hidden",
  backgroundColor: theme.palette.action.hover,
}));

const Slice = styled(FeedOutcomeSwatch)<{ $share: number }>(({ $share }) => ({
  width: `${$share * 100}%`,
}));

interface FeedOutcomeBarProps {
  statistics: CorpusFeedStatistics;
}

/** A thin bar showing what became of the papers a feed returned: one slice per outcome, in
 *  proportion. Read aloud as the counts it draws. */
export const FeedOutcomeBar = memo(function FeedOutcomeBar({ statistics }: FeedOutcomeBarProps) {
  const outcomes = feedOutcomeCounts(statistics);
  const description =
    outcomes.length === 0
      ? "No papers yet"
      : outcomes.map((outcome) => `${outcome.label} ${outcome.count}`).join(", ");

  return (
    <Track role="img" aria-label={description} title={description}>
      {outcomes.map((outcome) => (
        <Slice
          key={outcome.key}
          $outcome={outcome.key}
          $share={outcome.count / statistics.returnedCount}
        />
      ))}
    </Track>
  );
});
